module.exports = __webpack_public_path__ + "img/MCD_McDrive_Half_Teaser_01.9910d6ad.jpg";